import React from 'react';

export const CodoAIIcon = ({ fill, width, height, className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M3.9125 0.17461C3.85489 0.105397 3.77913 0.053604 3.69373 0.0250406C3.60832 -0.00352283 3.51665 -0.00772734 3.42899 0.0128986C3.34132 0.0335247 3.26114 0.0781658 3.19744 0.141815C3.13373 0.205463 3.08901 0.285603 3.0683 0.373245L2.40009 3.19332L0.174473 5.04876C0.10526 5.10637 0.0534673 5.18213 0.0249038 5.26753C-0.00365954 5.35294 -0.00786405 5.44461 0.012762 5.53228C0.0333881 5.61994 0.078029 5.70012 0.141678 5.76383C0.205327 5.82753 0.285466 5.87225 0.373108 5.89296L3.19319 6.56117L5.04877 8.78742C5.10638 8.85663 5.18214 8.90842 5.26755 8.93699C5.35295 8.96555 5.44463 8.96975 5.53229 8.94913C5.61995 8.9285 5.70013 8.88386 5.76384 8.82021C5.82755 8.75656 5.87226 8.67642 5.89297 8.58878L6.56118 5.7687L8.78743 3.91312C8.85664 3.85551 8.90843 3.77975 8.937 3.69434C8.96556 3.60894 8.96977 3.51726 8.94914 3.4296C8.92851 3.34194 8.88387 3.26176 8.82022 3.19805C8.75658 3.13434 8.67644 3.08963 8.58879 3.06892L5.76871 2.40071L3.9125 0.17461Z"
                fill={fill || "url(#paint0_linear_193_926)"}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_193_926"
                    x1="3.42961"
                    y1="0.0127507"
                    x2="5.53229"
                    y2="8.94913"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#0F6E32" />
                    <stop offset="1" stopColor="#21A457" />
                </linearGradient>
            </defs>
        </svg>
    );
};